export const tags = {
  vehicle: {
    pageVehicleFound: 'mod vehicle:vehicle found',
    refileads: 'refileads_vehicle',
    selected: (year, make, model) =>
      `vehicle selected: ${year} ${make} ${model}`,
    changeVehicle: 'change vehicle selected',
    lexisVehiclesFound: (number) => `lexis vehicles found: ${number}`,
    lexisVehiclesEligible: (number) => `lexis vehicles eligible: ${number}`,
    lexisVehiclesNotEligible: (number) =>
      `lexis vehicles ineligible: ${number}`,
  },
  default: {
    loan: {
      pagename: 'loan',
      manualToggle: (val) => `manual entry toggled ${val}`,
      manualSubmit: 'manual entry submit',
    },
    chooseVehicle: {
      pagename: 'vehicle:vehicle found',
      multiVehicle: 'multiple vehicles',
      ineligible: 'ineligible error',
      changeVehicle: 'change vehicle',
    },
  },
  loan: {
    pagename: 'mod loan',
    refileads: 'refileds_loan',
    selected: (lenderName) => `TU loan selected ${lenderName}`,
    changeLoanSelected: 'change loan selected',
    tuLoansFound: (number) => `TU loans found ${number}`,
    loansEligible: (number) => `loans eligible ${number}`,
    loansNotEligible: (number) => `loans ineligible ${number}`,
  },
  shared: {
    loan: {
      warning: {
        pagename: 'loan:isCapOneFinanced',
      },
      current: {
        manualHighLtv: 'manual entry high ltv',
        negativeApr: 'error negative apr warning',
        paymentHigh: 'error mthly pmt too high',
        paymentLow: 'error mthly pmt 0',
        balanceHigh: 'error balance too high',
        balanceLow: 'error balance too low',
      },
      submittedYes: 'submitted yes isCapitalOneLoaned',
      submittedNo: 'submitted no isCapitalOneLoaned',
      submittedYesLease: 'submitted yes isLease',
      submtitedNoLease: 'submitted no isLease',
      highLtv: 'high ltv',
      noTuLoans: 'no loans from TU',
      loanEligible: 'eligible loan',
      loanEligibleMulti: 'eligible loans multiple',
      loanIneligible: 'ineligible loan',
      loanIneligibleMulti: 'ineligible loans multiple',
      changePmtDueDate: (formname) => `change pmt due date ${formname}`,
    },
    vehicle: {
      lookup: {
        pagename: 'vehicle:vin lookup',
        continue: (inputs) => `continue ${inputs}`,
        notFound: 'vehicle not found',
        plateSuccessCarfax: 'license plate success carfax',
        vinSearch: 'vin search nada',
        carfaxDown: 'carfax api down error',
        nadaDown: 'nada api down error',
      },
      card: {
        ineligible: (reason) => `ineligible ${reason}`,
      },
      service: {
        ssnSearch: 'bff ssn search',
        vinSearch: 'bff vin search',
        licensePlateSearch: 'bff license plate search',
      },
      lexisSuccess: 'lexis nexis success',
      lexisFound: 'lexis vehicles found',
      lexisEligible: 'lexis vehicle eligible',
      lexisIneligible: 'lexis vehicle ineligible',
    },
    loanCard: {
      ineligible: (loan) => `ineligible loan ${loan}`,
      noApr: 'no apr',
      noOpenDate: 'no open date',
      noLender: 'no lender name',
      noLastPaymentDate: 'no last pmt date',
      useCalculatedBalance: 'use calculated balance',
      useTuBalance: 'use tu balance',
      tuLoanSelected: 'tu loan selected',
    },
    eligibilityLink: 'eligibility link',
  },
  vehicleAndLoan: {
    pagename: 'mod vehicle-loan',
    pageMatchFound: 'mod vehicle-loan:match found',
    searchSuccess: 'vehicle and loan search success',
    isMatchFound: 'vehicle and loan match found',
    noMatchFound: 'vehicle and loan match not found',
    matchFound: (number) =>
      `number of vehicle and loan matches found ${number}`,
    matchesShown: 'vehicle and loan matches shown',
    matchesNotShown: 'vehicle and loan matches not shown',
    matchedVehicleEligible: 'matched vehicle eligible',
    matchedVehicleNotEligible: 'matched vehicle ineligible',
    matchedLoanEligible: 'matched loan eligible',
    matchedLoanNotEligible: 'matched loan ineligible',
    selected: (year, make, model, lenderName) =>
      `vehicle and loan match selected: ${year} ${make} ${model} - ${lenderName}`,
    changeVehicleOrLoan: 'change vehicle or loan selected',
    paprModalShown: (apr, minApr) =>
      `papr modal shown for apr ${apr} < minimum ${minApr}`,
    paprContinueClicked: 'papr limit continue prequal',
    paprExitClicked: 'papr limit exit prequal',
  },
};
